export { default as Login } from '@S/Login.vue';
export { default as Register } from '@S/Register.vue';
export { default as ForgotPassword } from '@S/ForgotPassword.vue';
export { default as ResetEmailSent } from '@S/ResetEmailSent.vue';
export { default as PasswordReset } from '@S/PasswordReset.vue';
export { default as PasswordSet } from '@S/PasswordReset.vue';
export { default as PasswordResetSuccess } from '@S/PasswordResetSuccess.vue';
export { default as VerifyAccount } from '@S/VerifyAccount.vue';
export { default as VerifyCallback } from '@S/VerifyCallback.vue';
export { default as Landing } from '@S/Landing.vue';

// My Subscriptions:
export { default as SubscriptionsIndex } from '@S/MySubscriptions/Index.vue';
export { default as SubscriptionsBilling } from '@S/MySubscriptions/Billing.vue';
export { default as SubscriptionsPayment } from '@S/MySubscriptions/Payment.vue';
export { default as SubscriptionsTeaser } from '@S/MySubscriptions/Teaser.vue';

// Enrolment Stages:
export { default as BeginEnrolment } from '@S/Enrolment/Begin.vue';
export { default as EnrolmentPersonal } from '@S/Enrolment/Personal.vue';
export { default as EnrolmentHomeAddress } from '@S/Enrolment/HomeAddress.vue';
export { default as EnrolmentSubscription } from '@S/Enrolment/Subscription.vue';
export { default as EnrolmentBillingAddress } from '@S/Enrolment/BillingAddress.vue';
export { default as EnrolmentConfirmation } from '@S/Enrolment/Confirmation.vue';
export { default as EnrolmentPayment } from '@S/Enrolment/Payment.vue';
export { default as EnrolmentFailedPayment } from '@S/Enrolment/FailedPayment.vue';
export { default as EnrolmentSuccess } from '@S/Enrolment/Success.vue';

// iFrame widgets
export { default as Settings } from '@S/Widgets/Settings.vue';
export { default as EditProfile } from '@S/Widgets/EditProfile.vue';
export { default as WidgetError } from '@S/Widgets/Error.vue';
export { default as WidgetPasswordReset } from '@S/Widgets/PasswordReset.vue';
export { default as WidgetSeeItInAction } from '@S/Widgets/SeeItInAction.vue';
export { default as UpgradeSubscription } from '@S/Widgets/UpgradeSubscription.vue';
export { default as UpgradeSubscriptionTeaser } from '@S/Widgets/UpgradeSubscriptionTeaser.vue';
export { default as UpgradeSubscriptionPayment } from '@S/Widgets/UpgradeSubscriptionPayment.vue';
export { default as CancelSubscription } from '@S/Widgets/CancelSubscription.vue';
export { default as CancelSubscriptionSuccess } from '@S/Widgets/CancelSubscriptionSuccess.vue';
export { default as Personalise } from '@S/Widgets/Personalise.vue';



// WEBPACK FOOTER //
// ./resources/assets/js/stages/index.js